import type { PanelFilters } from '../domain/PanelFilters';

/**
 * Empty panel filters state - only includes filters managed within the filter panel
 * Excludes userId and subjectId which are managed outside the panel
 */
export const emptyPanelFilters: PanelFilters = {
  contentTypes: [],
  labels: [],
  languageDetected: undefined,
  topics: [],
  startDate: undefined,
  endDate: undefined,
  isSampled: true, // Default to sampled content
  policyFilter: undefined, // Default to show all content
  metadata: undefined,
};
